import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        withdrawals_history: {
          header: 'HEADER',
          download_report_button: 'DOWNLOAD_REPORT',
          state: {
            paid: 'STATE_PAID',
            canceled: 'STATE_CANCELED',
          },
          view_withdrawal: {
            header: 'VIEW_HEADER',
            back: 'VIEW_BACK',
            form: {
              merchant_name: 'FORM_MERCHANT_NAME',
              affiliate_email: 'FORM_AFFILIATE_EMAIL',
              affiliate_id: 'FORM_AFFILIATE_ID',
              affiliate_username: 'FORM_AFFILIATE_USERNAME',
              amount: 'FORM_AMOUNT',
              payment_method_type: 'FORM_PAYMENT_METHOD',
              created_at: 'FORM_CREATED_AT',
              admin_email: 'FORM_ADMIN_EMAIL',
              state: 'FORM_STATE',
              payment_system_name: 'FORM_PAYMENT_SYSTEM_NAME',
              creator_type: 'FORM_CREATOR_TYPE',
              creator_id: 'FORM_CREATOR_ID',
              creator_email: 'FORM_CREATOR_EMAIL',
            },
          },
        },
      },
    },
  }));
}
